var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.023 20.036"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(-3158.607 -907.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M3168.625,927.834a10.018,10.018,0,1,1,7.09-17.1.315.315,0,1,1-.445.446,9.388,9.388,0,1,0,2.749,6.632.3.3,0,0,1,.306-.3.309.309,0,0,1,.3.3,10.009,10.009,0,0,1-10,10.018",
    fill: "#4c4c4c"
  })))));
};
export default __webpack_public_path__ + "static/media/not_selected_language.88e7bc4f.svg";
export { SvgComponent as ReactComponent };